import {Device} from '../../constants';
import React from 'react';
import styled from 'styled-components';

interface Props {
  className: string;
  children: React.ReactNode;
}

export const RedeemSectionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 5%;
  background-repeat: no-repeat;
  background-size: cover;
  @media screen and ${Device.laptop} {
    flex-direction: column;
  }
  @media screen and ${Device.mobileL} {
    font-size: 14px;
  }
  > div {
    flex: 1;
  }
  .ecrrs-left {
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .ecrrs-right {
    max-width: 800px;
    padding: 3%;
    margin-left: 2em;
  }
  button {
    outline: none;
    border: none;
  }
`;

const RedeemSectionContainerExtended = ({className = '', children, ...rest}: Props) => (
  <RedeemSectionContainer className={className} {...rest}>
    {children}
  </RedeemSectionContainer>
);

export default RedeemSectionContainerExtended;
